import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/';

axios.interceptors.request.use(async (config) => {
    let accessToken = sessionStorage.getItem('access_token');

    if (!accessToken) {
        return config;
    }

    if (isTokenExpired(accessToken)) {
        if (config.url.includes('token/refresh/')) {
            return config;
        }
        try {
            accessToken = await refreshToken();
        } catch (error) {
            console.error('Failed to refresh token:', error.detail);
            // Handle token refresh failure (e.g., redirect to login)
        }
    }

    if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

export function isTokenExpired(token) {
    if (!token) {
        return true;
    }

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decoded.exp < currentTime;
    } catch (error) {
        console.error('Invalid token:', error);
        return true;
    }
}


export const authenticateUser = async (username, password) => {
    try {
        const response = await axios.post(`${API_URL}token/`, { username, password });
        sessionStorage.setItem('access_token', response.data.access);
        sessionStorage.setItem('refresh_token', response.data.refresh);
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const refreshToken = async () => {
    try {
        const refresh_token = sessionStorage.getItem('refresh_token');
        const response = await axios.post(`${API_URL}token/refresh/`, { refresh: refresh_token });
        sessionStorage.setItem('access_token', response.data.access);
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
        return response.data;
    } catch (error) {
        throw error;
    }
};
export function isValidToken(token) {
    if (!token || token.trim() === '') {
        return false;
    }

    // Check if the token is a valid JWT
    const parts = token.split('.');
    if (parts.length !== 3) {
        return false;
    }

    try {
        // Decode the token to check its payload
        const decoded = jwtDecode(token);

        // Check if the token has expired
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            return false;
        }

        // Additional checks can be added here (e.g., issuer, audience)
        return true;
    } catch (error) {
        console.error('Invalid token:', error);
        return false;
    }
}